import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import TransactionsSection, { TRANSACTIONS_SECTION_ENABLED } from '../../../../../components/TransactionsSection';
import PreviewField, { PreviewFieldGrid, PreviewSectionHeading, previewFieldLabelStyle } from '../../../../../components/PreviewField';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import accounting from 'accounting';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class UpdateTenantRentModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    newRentalPayments: null,
    recievedRent: null,
    receivedNetRent: null, 
    receivedAdvancePayment: null,
    rentalPaymentsForModal: []
  };

  descriptionMsgStyle={
    fontFamily: 'Inter, sans-serif',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#0e0e1d',
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount(){
    const {selectedRentModalData, rentalPaymentsForModal} = this.props;
    this.setState({receivedRent: selectedRentModalData.receivedRent, receivedNetRent: selectedRentModalData.receivedNetRent, receivedAdvancePayment: selectedRentModalData.receivedAdvancePayment, newRentalPayments: selectedRentModalData, rentalPaymentsForModal});
  }

  // The parent swaps in a freshly fetched record after a bank-transaction assignment changes.
  // Take over the recalculated received amounts, otherwise "Speichern" would write the stale
  // values back over them.
  componentDidUpdate(prevProps){
    const {selectedRentModalData} = this.props;
    if(selectedRentModalData && selectedRentModalData !== prevProps.selectedRentModalData){
      this.setState({receivedRent: selectedRentModalData.receivedRent, receivedNetRent: selectedRentModalData.receivedNetRent, receivedAdvancePayment: selectedRentModalData.receivedAdvancePayment, newRentalPayments: selectedRentModalData});
    }
  }

  render() {
    const { open, toggle, className, selectedRentModalData, isMobile } = this.props;
    const { receivedRent, receivedNetRent, receivedAdvancePayment, rentalPaymentsForModal } = this.state;
    
    return (
      <CustomModal
        heading={'Zahlungseingang'}
        headingClassName={'tenant-rent-tracking-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
        style={{
            width: !isMobile && '450px'
        }}
      >
        {/* Inline px gap, not the gap prop: Mantine's rem spacing renders 14/16 of the number here
            (see PreviewField.jsx). 20px between the last section and the action buttons. */}
        <Stack style={{ gap: 20 }}>
            <Stack>
              <Stack gap={0}>
                <PreviewSectionHeading>Mieterdaten</PreviewSectionHeading>
                <PreviewFieldGrid>
                  <PreviewField label='Mieter' value={selectedRentModalData.tenant.fullName} />
                  <PreviewField label='Einheit' value={selectedRentModalData.tenant.rentalUnitName} />
                  <PreviewField label='Monat' value={dayjs(selectedRentModalData.rentalMonth).locale('de').format('MMMM YYYY')} />
                </PreviewFieldGrid>
              </Stack>
              <Stack gap={0} mt={12}>
                <PreviewSectionHeading>Mietzahlung</PreviewSectionHeading>
                <Stack gap={12}>
                  <Group>
                    <Checkbox
                    classNames={{input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner'}}
                    checked={(receivedNetRent + receivedAdvancePayment) == (selectedRentModalData.expectedNetRent + selectedRentModalData.expectedAdvancePayment)}
                    label={`Vertragsmiete (${accounting.formatMoney((selectedRentModalData.expectedNetRent + selectedRentModalData.expectedAdvancePayment), '€', 2, '.', ',', '%v %s')}) erhalten`}
                    styles={{
                      label: {
                        fontSize: '14px',
                        marginBottom: 0
                      }
                    }}
                    onChange={()=> {
                      this.setState({
                        receivedNetRent: (((receivedNetRent + receivedAdvancePayment) >= (selectedRentModalData.expectedNetRent + selectedRentModalData.expectedAdvancePayment)) ? 0 : selectedRentModalData.expectedNetRent),
                        receivedAdvancePayment: (((receivedNetRent + receivedAdvancePayment) >= (selectedRentModalData.expectedNetRent + selectedRentModalData.expectedAdvancePayment)) ? 0 : selectedRentModalData.expectedAdvancePayment)
                      });
                    }}
                    />
                  </Group>
                  <Group align="flex-start" gap={24} wrap="nowrap">
                    <Stack gap={12} style={{flex: 1}}>
                      <Stack gap={0}>
                        <span style={previewFieldLabelStyle}>Erhaltene Kaltmiete</span>
                        <NumericFormat
                        className={`form-control ${receivedNetRent === selectedRentModalData.expectedNetRent ? 'rental-income-payment-column-full-paid-modal' : (receivedNetRent > 0) ? 'rental-income-payment-column-partial-paid-modal' : 'rental-income-payment-column-not-paid-modal'}`}
                        value={receivedNetRent}
                        thousandSeparator="."
                        decimalSeparator=","
                        onValueChange={(values, sourceInfo) => {
                          this.setState({
                            receivedNetRent: values.floatValue});
                        }}
                        suffix={' €'}
                        placeholder='0,00 €'
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={true}
                        style={{paddingLeft: 10, background: receivedNetRent === selectedRentModalData.expectedNetRent ? '#e8f4ea' : (receivedNetRent > 0) ? '#f7e3cd' : '#FFCBCB'}}
                        />
                      </Stack>
                      <Stack gap={0}>
                        <span style={previewFieldLabelStyle}>Erhaltene Vorauszahlungen</span>
                        <NumericFormat
                        className={`form-control ${receivedAdvancePayment === selectedRentModalData.expectedAdvancePayment ? 'rental-income-payment-column-full-paid-modal' : (receivedAdvancePayment > 0) ? 'rental-income-payment-column-partial-paid-modal' : 'rental-income-payment-column-not-paid-modal'}`}
                        value={receivedAdvancePayment}
                        thousandSeparator="."
                        decimalSeparator=","
                        onValueChange={(values, sourceInfo) => {
                          this.setState({
                            receivedAdvancePayment: values.floatValue});
                        }}
                        suffix={' €'}
                        placeholder='0,00 €'
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={true}
                        style={{paddingLeft: 10, background: receivedAdvancePayment === selectedRentModalData.expectedAdvancePayment ? '#e8f4ea' : (receivedAdvancePayment > 0) ? '#f7e3cd' : '#FFCBCB'}}
                        />
                      </Stack>
                    </Stack>
                    <Stack gap={12} style={{flex: 1}}>
                      <Stack gap={0}>
                        <span style={previewFieldLabelStyle}>Erwartete Kaltmiete</span>
                        <NumericFormat
                        className='form-control'
                        value={selectedRentModalData.expectedNetRent}
                        thousandSeparator="."
                        decimalSeparator=","
                        suffix={' €'}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={true}
                        disabled
                        style={{paddingLeft: 10, background: '#F7F7FA', color: '#727293'}}
                        />
                      </Stack>
                      <Stack gap={0}>
                        <span style={previewFieldLabelStyle}>Erwartete Vorauszahlungen</span>
                        <NumericFormat
                        className='form-control'
                        value={selectedRentModalData.expectedAdvancePayment}
                        thousandSeparator="."
                        decimalSeparator=","
                        suffix={' €'}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={true}
                        disabled
                        style={{paddingLeft: 10, background: '#F7F7FA', color: '#727293'}}
                        />
                      </Stack>
                    </Stack>
                  </Group>
                </Stack>
              </Stack>
              {TRANSACTIONS_SECTION_ENABLED &&
              <Stack gap={0} mt={12}>
                <PreviewSectionHeading>Bankumsätze</PreviewSectionHeading>
                <TransactionsSection
                tenantId={selectedRentModalData.tenantId}
                rentalPaymentId={selectedRentModalData.id}
                rentalMonth={selectedRentModalData.rentalMonth}
                totalAmount={(receivedNetRent || 0) + (receivedAdvancePayment || 0)}
                onAssignmentsChanged={this.props.onAssignmentsChanged}
                />
              </Stack>}

            </Stack>
            {isMobile &&
            <div>
              <ColorButton
              text={<span style={{whiteSpace: 'nowrap'}}>Mahnung senden</span>}
              className='gray-btn'
              onClick={()=> this.props.history.push('/messaging/newMessage', {messageType: 'tenantRentMessage', tenantId: selectedRentModalData.tenantId, rentalPaymentId: selectedRentModalData.id})}
              />
            </div>}
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Speichern'}
                    className='purple-btn'
                    onClick={()=> this.props.saveRentValues([], receivedRent, receivedNetRent, receivedAdvancePayment, selectedRentModalData.id)}
                    />
                </div>
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default UpdateTenantRentModal;
